RivalIQ.apps.Overview.module('utils', function (utils, App, Backbone, Marionette, $, _, NumberToWords) {

    'use strict';


    utils.getSelectedBenchmarkCompareAgainst = function (selectedBenchmarkCompareAgainstId) {
        const selectedBenchmarkCompareAgainst = _.find(RivalIQ.enums.benchmarkCompareAgainstOptions, {
            id: selectedBenchmarkCompareAgainstId || RivalIQ.state.landscape.get('selectedBenchmarkCompareAgainst')
        }) || RivalIQ.enums.benchmarkCompareAgainstOptions[0];

        return selectedBenchmarkCompareAgainst;
    };

    utils.getCompaniesForFilter = function (benchmarkCompaniesFilter, dashboardModel) {
        let companies = RivalIQ.state.landscape.getCompaniesByCompanySet(dashboardModel.getProp('companySetDescriptor'));

        if (benchmarkCompaniesFilter === RivalIQ.enums.benchmarkCompaniesFilters.exclude_focus_company.id) {
            const focusCompanyId = dashboardModel.getProp('focusCompanyId');
            companies = _.reject(companies, {
                id: focusCompanyId
            });
        }

        return companies;
    };

    utils.makePossessive = function (companyName) {
        companyName = _.trim(companyName);

        // T.G.I. Friday's -> T.G.I. Friday's
        if (!_.endsWith(companyName, `'s`)) {
            if (_.endsWith(companyName, 's')) {
                // Seahawks -> Seahawks'
                companyName = `${companyName}'`;
            } else {
                companyName = `${companyName}'s`;
            }
        }

        return companyName;
    };

    utils.numToWords = function (num) {
        if (num > 9 || num === 0) {
            return RivalIQ.formatter.formats.integer(num);
        } else {
            return NumberToWords.toWords(num);
        }
    };

}, window.NumberToWords);
